export default "__VITE_ASSET__BwntunNk__"